export default "__VITE_ASSET__5348bbe6__"